import { CreateMemorials } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.CREATEMEMORIALS.path,
      name: "CREATEMEMORIALS",
      key: routesMap.CREATEMEMORIALS.path,
      private: true,
      element: <CreateMemorials />,
    },
    {
      path: `${routesMap.CREATEMEMORIALS.path}/:id`,
      name: "CREATEMEMORIALS",
      key: `${routesMap.CREATEMEMORIALS.path}/:id`,
      private: true,
      element: <CreateMemorials />,
    },
  ];
}
